package pl.finn.forms.wouip

import io.kvision.core.onEvent
import io.kvision.form.FormHorizontalRatio
import io.kvision.form.text.Text
import io.kvision.form.text.TextArea
import io.kvision.panel.FieldsetPanel
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.fk02.DynamicFieldsValidator


class WouipBlocks (dfv: DynamicFieldsValidator){
    private val dynamicFieldsValidator = dfv
    val blokInfoDodatkowe: (InformacjeDodatkowe, String?) -> FieldsetPanel = { informacjeDodatkowe, elementsName ->
        FieldsetPanel(elementsName).apply {
            add(dynamicFieldsValidator.add(
                TextArea(
                    value =  informacjeDodatkowe.informacja,
                    label = "Treść",
                    rows = 10
                ).apply {
                    onEvent {
                        change = {
                            informacjeDodatkowe.informacja = self.value
                        }
                    }
                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                    flabel.addCssClass("required-label")
                },
                { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                POLE_WYMAGANE
            ))
        }
    }
    val blokOswiadczen: (Oswiadczenia, String?) -> FieldsetPanel = { oswiadczenia, elementsName ->
        FieldsetPanel(elementsName).apply {
            add(dynamicFieldsValidator.add(
                Text(
                    value =  oswiadczenia.oswiadczenie,
                    label = "Treść oświadczenia"
                ).apply {
                    onEvent {
                        change = {
                            oswiadczenia.oswiadczenie = self.value
                        }
                    }
                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                    flabel.addCssClass("required-label")
                },
                { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                POLE_WYMAGANE
            ))
        }
    }


}